import { drilldownData, ModuleFields } from "~/Utils/drilldownData";

const mapFields = (data: ModuleFields[]) =>{
 return(
  data.map(({ fieldName, placeholder, name, formType, validation, className, options, usedFileType,note, imageDimension }) => ({
    name: name,
    type: formType,
    label: fieldName,
    placeholder: placeholder,
    validation: validation,
    className: className,
    options:options,
    usedFileType: usedFileType,
    note: note,
    imageDimension: imageDimension
  }))
 )
}

export const fields: any = {
  socialMediaIcons: mapFields(drilldownData["socialMediaIcons"]),
  contactCentre: mapFields(drilldownData["contactCentre"]),
  copyrights: mapFields(drilldownData["copyrights"]),
  contents: mapFields(drilldownData["contents"]),
  eramanLogo: mapFields(drilldownData["eramanLogo"]),
  aboutEraman: mapFields(drilldownData["aboutEraman"]),
  eramanPrivilege: mapFields(drilldownData["eramanPrivilege"]),
  travellersInfo: mapFields(drilldownData["travellersInfo"])
};
